<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login">
				<div class="user-login-title"><a href="/">首页</a> / <span>商品详情</span></div>
				<div class="goods" v-if="show">
					<div class="goods-info flex-between">
						<img class="goods-info-img" :src="info.listImage[imageIndex]"/>
						<div class="goods-info-list">
							<img v-for="(item, index) in info.listImage" :class="imageIndex == index?'active':''" :src="item" @click="imageIndex = index"/>
						</div>
						<div class="goods-info-text">
							<div class="flex-between flex-center">
								<div class="goods-info-text-left">
									<div class="goods-info-text-name">{{info.name}}</div>
									<div class="goods-info-text-info">{{info.info}}</div>
								</div>
								<div class="goods-info-text-price">
									<div>￥{{specInfo.presentPrice}}</div>
									<div>商品价格: </div>
								</div>
							</div>
							
							<div class="rule flex-start">
								<div class="rule-title">{{ruleList[goodsSpecList[onekey].specTypeId]}}：</div>
								<div class="rule-list flex-start flex-center flex-wrap">
									<div class="rule-list-item" v-for="(item,index) in goodsSpecList" :class="onekey==index?'active':''" @click="changeOne(index)">
									
										<img class="image-icon" :src="item.image"/>
										<div>{{item.name}}</div>
									</div>
								</div>
							</div>
							
							
							<template v-if="twokey > -1">
								<div class="rule flex-start">
									<div class="rule-title">{{ruleList[goodsSpecList[onekey].childrenList[twokey].specTypeId]}}：</div>
									<div class="rule-list flex-start flex-center flex-wrap">
										<div class="rule-list-item" v-for="(item,index) in goodsSpecList[onekey].childrenList" :class="twokey==index?'active':''" @click="changeTwo(index)">
											<img class="image-icon" :src="item.image"/>
											<div>{{item.name}}</div>
										</div>
									</div>
								</div>
							</template>
							
							
							<div class="cart-action flex-start flex-center">
								<i v-if="num > 1 && num > info.minOrderNum" @click="jian" style="font-size: 30px;color: #000;" class="el-icon-remove-outline"></i>
								<i v-else class="el-icon-remove-outline" :title="'最少购买'+info.minOrderNum+'件'" style="font-size: 30px;color: rgb(144, 147, 153);"></i>
								<el-input-number style="width: 140px;" v-model="num" @blur="changeNum" :controls="false" label="请输入购买数量"></el-input-number>
								<i v-if="num < specInfo.stockNum" @click="add" style="font-size: 30px;color: #000;" class="el-icon-circle-plus-outline"></i>
								<i v-else class="el-icon-circle-plus-outline" style="font-size: 30px;color: rgb(144, 147, 153);"></i>
							</div>
							
							<div class="action-button flex-start flex-center">
								<div @click="submit">立即购买</div>
								<div @click="addCart">加入购物车</div>
							</div>
							
						</div>
					</div>
					
					<div class="goods-title">商品详情</div>
					
					<div class="content">
						<el-row :gutter="60">
						  <el-col :span="8" v-for="item in info.paramList" :key="item.id">
							  <div class="param-item">
								  <span>{{item.name}}</span>{{item.info}}
							  </div>
						  </el-col>
						</el-row>
						<img v-for="item in info.detailImage" class="content-image" :src="item"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getGoodsInfo} from "@/api/index"
	import {addShoppingCart} from "@/api/user"
	export default {
		data(){
			return {
				show:false,
				id:0,
				info:{listImage:[],paramList:[],goodsSpecList:[],detailImage:[]},
				ruleList:[],
				onekey:0,
				twokey:0,
				specInfo:{},
				goodsSpecList:[],
				imageIndex:0,
				num:1
			}
		},
		mounted() {
			this.id = this.$route.query.id || "";
			this.getInfo();
		},
		methods:{
			getInfo(){
				getGoodsInfo({goodsId:this.id}).then(res=>{
					if(res.code == 1000){
						res.data.listImage = res.data.listImage.split(",");
						res.data.detailImage = res.data.detailImage.split(",");
						let ruleList = {};
						res.data.specTypeList.map(item=>{
							ruleList[item.id] = item.name;
						})
						this.ruleList = ruleList;
						if(res.data.goodsSpecList[this.onekey].childrenList != null && res.data.goodsSpecList[this.onekey].childrenList.length > 0){
							this.specInfo = res.data.goodsSpecList[this.onekey].childrenList[this.twokey];
							this.twokey = 0;
						}else{
							this.specInfo = res.data.goodsSpecList[this.onekey];
							this.twokey = -1;
						}
						this.goodsSpecList = res.data.goodsSpecList;
						this.info = res.data;
						if(this.info.minOrderNum == 0){
							this.num = 1;
						}else{
							this.num = this.info.minOrderNum;
						}
						
						this.show = true;
					}else{
						return this.$message.error(res.message);
					}
					
				})
			},
			changeTwo(e){
				this.twokey = e;
				this.specInfo = {pname:this.goodsSpecList[this.onekey].name,...this.goodsSpecList[this.onekey].childrenList[this.twokey]};
				if(this.num >= this.specInfo.stockNum){
					this.num = this.specInfo.stockNum;
				}
				if(this.num <= this.info.minOrderNum){
					this.num = this.info.minOrderNum;
				}
			},
			changeOne(e){
				this.onekey = e;
				if(this.goodsSpecList[this.onekey].childrenList != null && this.goodsSpecList[this.onekey].childrenList.length > 0){
					this.twokey = 0;
					this.specInfo = this.goodsSpecList[this.onekey].childrenList[this.twokey];
				}else{
					this.specInfo = this.goodsSpecList[this.onekey];
					this.twokey = -1;
					if(this.num >= this.specInfo.stockNum){
						this.num = this.specInfo.stockNum;
					}
					if(this.num <= this.info.minOrderNum){
						this.num = this.info.minOrderNum;
					}
				}
			},
			jian(){
				if(this.num <= this.info.minOrderNum){
					this.num = this.info.minOrderNum;
				}else{
					this.num--;
				}
				if(this.num < 1){
					if(this.info.minOrderNum == 0){
						this.num = 1;
					}else{
						this.num = this.info.minOrderNum;
					}
				}
			},
			add(){
				if(this.num >= this.specInfo.stockNum){
					this.num = this.specInfo.stockNum;
				}else{
					this.num++;
				}
				if(this.num <= this.info.minOrderNum){
					this.num = this.info.minOrderNum;
				}
				
				if(this.num < 1){
					if(this.info.minOrderNum == 0){
						this.num = 1;
					}else{
						this.num = this.info.minOrderNum;
					}
				}
			},
			changeNum(e){
				if(this.num >= this.specInfo.stockNum){
					this.num = this.specInfo.stockNum;
					this.$message.error("库存不足");
				}
				if(this.num <= this.info.minOrderNum){
					this.num = this.info.minOrderNum;
					this.$message.error("最小起订量为"+this.info.minOrderNum);
				}
				if(this.num < 1){
					this.num = 1;
				}
			},
			//加入购物车
			addCart(){
				if(this.$store.state.user == null){
					this.$router.push("/login");
				}else{
					addShoppingCart({
						goodsId:this.id,
						goodsSpecId:this.specInfo.id,
						num:this.num
					}).then(res=>{
						if(res.code == 1000){
							this.$message.success("加入成功");
							this.$store.dispatch('fetchCartNum');
						}else{
							return this.$message.error(res.message);
						}
					})
				}
			},
			//立即购买
			submit(){
				if(this.$store.state.user == null){
					this.$router.push("/login");
				}else{
					if(this.num <= this.specInfo.stockNum){
						this.$router.push("/submit?id="+this.specInfo.id+"&num="+this.num);
					}else{
						this.$message.error("商品库存不足");
					}
					
				}
			}
		}
	}
</script>
<style scoped lang="scss">
	.content{
		width: 1320px;
		background: #FFFFFF;
		padding: 30px;
		box-sizing: border-box;
		.content-image{
			width: 100%;
			height: auto;
			vertical-align: middle;
			display: block;
		}
		.param-item{
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			font-size: 16px;
			line-height: 24px;
			color: #070B13;
			padding: 18px 0px;
			span{
				color: #070B13;
				opacity: 0.4;
				width: 116px;
				display: inline-block;
			}
		}
	
	}
	.goods-title{
		font-size: 22px;
		line-height: 80px;
		text-align: left;
		color: #070B13;
	
	}
	.action-button{
		margin-top: 80px;
		div{
			margin: 0px 10px;
			cursor: pointer;
			&:first-of-type{
				width: 180px;
				height: 56px;
				background: #E91A12;
				border: 1px solid #E91A12;
				font-size: 18px;
				font-weight: 500;
				line-height: 56px;
				text-align: center;
				color: #FFFFFF;
			}
			&:last-of-type{
				width: 180px;
				height: 56px;
				background: #fff;
				border: 1px solid #E91A12;
				font-size: 18px;
				font-weight: 500;
				line-height: 56px;
				text-align: center;
				color: #070B13;
			}
		}
	}
	.cart-action{
		margin-top: 60px;
		img{
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
		div{
			font-size: 24px;
			font-weight: 500;
			line-height: 24px;
			color: #060707;
			padding: 0px 24px;
		}
	}
	.rule{
		margin-top: 30px;
		.rule-title{
			width: 80px;
			height: 28px;
			font-size: 16px;
			line-height: 28px;
			color: #9E9E9E;
			text-align: left;
			padding-top: 10px;
		}
		.rule-list{
			width: 100%;
			.rule-list-item{
				text-align: center;
				padding: 0px 15px 15px;
				cursor: pointer;
				.image-icon{
					width: 46px;
					height: 46px;
					border: 1px solid rgba(0, 0, 0, 0.1);
					object-fit: cover;
				}
				div{
					font-size: 12px;
					line-height: 16px;
					margin-top: 4px;
					color: #070B13;
				}
			}
			.active{
				.image-icon{
					border: 1px solid #E91A12;
				}
			}
		}
	}
	.goods-info{
		width: 1320px;
		background: #FFFFFF;
		padding: 30px;
		box-sizing: border-box;
		.goods-info-text{
			width: 100%;
			.goods-info-text-price{
				text-align: right;
				flex: 0 0 160px;
				div{
					&:first-of-type{
						font-size: 32px;
						font-weight: 500;
						line-height: 40px;
						color: #E91A12;
					}
					&:last-of-type{
						font-size: 16px;
						color: #070B13;
						margin-top: 8px;
					}
				}
			}
			.goods-info-text-name{
				font-size: 24px;
				font-weight: 500;
				line-height: normal;
				color: #070B13;
			}
			.goods-info-text-info{
				font-size: 16px;
				color: #070B13;
				margin-top: 20px;
				opacity: 0.6;
			}
		}
		.goods-info-img{
			width: 478px;
			height: 478px;
			border: 1px solid rgba(0, 0, 0, 0.1);
			flex: 0 0 480px;
			margin-right: 8px;
			object-fit: cover;
		}
		.goods-info-list{
			width: 114px;
			flex: 0 0 114px;
			margin-right: 30px;
			height: 478px;
			overflow-y: auto;
			img{
				width: 112px;
				height: 112px;
				border: 1px solid rgba(0, 0, 0, 0.1);
				margin-bottom: 8px;
				object-fit: cover;
			}
			.active{
				border: 1px solid #E91A12;
			}
		}
	}
</style>